
import { QuizInlineCardRoot } from "./QuizInlineCardRoot";
import { QuizInlineCardHeader } from "./Header";
import { QuizInlineCardItem } from "./Item";
import { QuizInlineCardActions } from "./Actions";

export const QuizInlineCard = Object.assign(QuizInlineCardRoot, {
  Header: QuizInlineCardHeader,
  Item: QuizInlineCardItem,
  Actions: QuizInlineCardActions,
});
